<template>
  <div>
    <HelloWorld/>
    <div class="container">
      <div class="content">
        <div class="text">
          <h1><img id="ima" src="/TabelaCorrelacao/img/box.svg" alt="Box Icon" style="width: 50px; margin-right: 12px;">Correlação NCM</h1>
          <p>Nos últimos anos, as NCMs passaram por diversas atualizações. Esta funcionalidade é um acompanhamento com as correlações entre os itens que já foram alterados.</p>
          <div class="button-group">
            <button @click="openCorrelationTable('2012-2017')">2012-2017</button>
            <button @click="openCorrelationTable('2017-2022')">2017-2022</button>
          </div>
        </div>
        <div class="image">
          <img src="/TabelaCorrelacao/img/details.svg" alt="Details Icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue';

export default {
  components: {
    HelloWorld
  },
  methods: {
    openCorrelationTable(yearRange) {
      let url = `https://www.lefisc.com.br/TabelaCorrelacao/${yearRange}.asp`;
      if (yearRange === '2017-2022') {
        url = `https://www.lefisc.com.br/TabelaCorrelacao/${yearRange}.pdf`;
      }
      window.open(url, '_blank');
    }
  }
};
</script>

<style>
body {
  background-color: #4A154B;
  margin: 0;
  padding: 0;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 60px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}

h1 {
  color: white;
  font-size: 30px;
  
  margin-top: 20px;
  margin-bottom: 50px;
}

p {
  color: white;
  max-width: 900px;
  font-size: 16px;
  font-weight: 500;
  margin-top: 80px;
}

.button-group {
  display: flex;
  flex-direction: column;
  margin-top: 90px;
}

button {
  width: 250px;
  height: 60px;
  background: #FFAA21;
  border-radius: 5px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  border: none;
}

.image {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  max-width: 300px;
}

#ima {
  height: auto;
}

* {
  box-sizing: border-box;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin: 0;
  padding: 0;
  outline: none;
}

@media (min-width: 768px) {
  .container {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 20px;
  }

  .content {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  h1 {
    font-size: 50px;
    margin-top: 0;
  }

  p {
    font-size: 20px;
    margin-top: 0;
    margin-right: 100px;
  }

  .button-group {
    flex-direction: row;
    align-items: center;
  }

  button {
    width: 300px;
    height: 80px;
    font-size: 18px;
    margin-bottom: 0;
    margin-right: 10px;
  }

  .image {
    margin-top: 0;
    max-width: 600px;
  }
}
</style>
